import { API_URL } from 'constants/config';
import callApi from 'utils/callApi';

/** 取得所有股票代號 */
export function getBQMarketName() {
  return callApi(`${API_URL}/StockPrice/BQMarketName`);
}
